import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, finalize, map, shareReplay } from 'rxjs/operators';
import { RestService } from 'src/app/shared/services/rest.service';
import { AnimalContactRelationModel } from '../models/animal-contact-relation.model';

@Injectable({ providedIn: 'root' })
export class AnimalContactRelationRepository {
  private readonly _inFlight = new Map<string, Observable<AnimalContactRelationModel[]>>();

  constructor(private readonly _restService: RestService) {
  }

  /** Alle Tier-Verknuepfungen eines Kontakts. */
  getByContactId(contactId: number | undefined): Observable<AnimalContactRelationModel[]> {
    if (!contactId) return of([]);
    return this.load(`contact=${contactId}`);
  }

  /** Alle Kontakt-Verknuepfungen eines Tieres. */
  getByAnimalId(animalId: number | undefined): Observable<AnimalContactRelationModel[]> {
    if (!animalId) return of([]);
    return this.load(`animal=${animalId}`);
  }

  private load(query: string): Observable<AnimalContactRelationModel[]> {
    const pending = this._inFlight.get(query);
    if (pending) return pending;

    const request$ = this._restService.httpGet(`/animal_contact_relations?${query}`).pipe(
      map((response: AnimalContactRelationModel[] | null) => Array.isArray(response) ? response : []),
      catchError(() => of([] as AnimalContactRelationModel[])),
      finalize(() => this._inFlight.delete(query)),
      shareReplay({ bufferSize: 1, refCount: false })
    );

    this._inFlight.set(query, request$);
    return request$;
  }
}
